if (!customElements.get("delivery-date")) {
  class DeliveryDate extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
      requestAnimationFrame(() => {
        this.init();
      });
    }

    init() {
      this.initDeliveryDates();
    }

    addDays(date, days) {
      const d = new Date(date);
      d.setDate(d.getDate() + days);
      return d;
    }

    monthsByLocale() {
      if (Shopify.locale !== "fr") {
        return ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
      }
      return ["Jan","Fév","Mar","Avr","Mai","Jun","Jui","Aout","Sep","Oct","Nov","Déc"];
    }

    formatDate(d) {
      const months = this.monthsByLocale();
      return d.getDate() + " " + months[d.getMonth()];
    }

    parseDateAny(input) {
      if (!input) return null;
      const s = String(input).trim();
      const parts = s.split('/');
      if (parts.length === 3 && parts[0].length === 2 && parts[2].length === 4) {
        const mm = parseInt(parts[0], 10) - 1;
        const dd = parseInt(parts[1], 10);
        const yyyy = parseInt(parts[2], 10);
        const d = new Date(yyyy, mm, dd);
        if (!isNaN(d.getTime())) return d;
      }
      const d = new Date(input);
      return isNaN(d.getTime()) ? null : d;
    }

    getExpectedDeliveryDate(incomingPoRaw) {
      if (!incomingPoRaw) return null;
      let obj = incomingPoRaw;
      if (typeof incomingPoRaw === "string") {
        const normalized = incomingPoRaw.replace(/&quot;/g, '"');
        try {
          obj = JSON.parse(normalized);
        } catch (e) {
          return null;
        }
      }
      const list = Array.isArray(obj) ? obj : [obj];
      let best = null;
      for (const item of list) {
        const val = item?.ExpectedDeliveryDate || item?.expecteddeliverydate;
        const d = this.parseDateAny(val);
        if (d && (!best || d < best)) best = d;
      }
      return best;
    }

    renderDeliveryRange(variantId, productId, baseDate, fromOffsetDays, toOffsetDays) {
      const cEl = this.querySelector(".prod_current_date");
      const nEl = this.querySelector(".prod_next_date");
      if (!cEl || !nEl) return;

      const fromDate = this.addDays(baseDate, fromOffsetDays);
      const toDate = this.addDays(baseDate, toOffsetDays);

      cEl.textContent = this.formatDate(fromDate);
      nEl.textContent = this.formatDate(toDate);

      const lineInput = document.querySelector(
        '.line-item-property__field[data-variant-id="' + variantId + '"] #delivery-date'
      );
      if (lineInput) {
        lineInput.value = "Approximate Delivery Date :" + this.formatDate(toDate);
      }
    }

    computeAndRender(el) {
      const productId = el.getAttribute("data-product-id");
      const variantId = el.getAttribute("data-variant-id");
      const inventoryQty = parseInt(el.getAttribute("data-inventory-qty") || "0", 10);
      let incomingRaw = el.getAttribute("data-incoming-po") || "";
      incomingRaw = incomingRaw.replace(/&quot;/g, '"');
      const expectedDate = this.getExpectedDeliveryDate(incomingRaw);

      if (inventoryQty > 0) {
        this.renderDeliveryRange(variantId, productId, new Date(), 5, 10);
        return;
      }
      if (expectedDate) {
        this.renderDeliveryRange(variantId, productId, expectedDate, 5, 10);
        return;
      }
      this.renderDeliveryRange(variantId, productId, new Date(), 125, 130);
    }

    initDeliveryDates() {
      const els = this.querySelectorAll(".meta_deliver");
      if (!els.length) return;

      const isProductPage = !!document.querySelector('body.template-product');

      if (isProductPage) {
        const activeEl = this.querySelector('.meta_deliver:not([style*="display:none"])') || els[0];
        if (activeEl) this.computeAndRender(activeEl);
      } else {
        let bestFromDate = null;
        let bestEl = null;

        els.forEach((el) => {
          const inventoryQty = parseInt(el.getAttribute("data-inventory-qty") || "0", 10);
          let incomingRaw = el.getAttribute("data-incoming-po") || "";
          incomingRaw = incomingRaw.replace(/&quot;/g, '"');
          const expectedDate = this.getExpectedDeliveryDate(incomingRaw);

          let fromDate;
          if (inventoryQty > 0) {
            fromDate = this.addDays(new Date(), 5);
          } else if (expectedDate) {
            fromDate = this.addDays(expectedDate, 5);
          } else {
            fromDate = this.addDays(new Date(), 125);
          }

          if (!bestFromDate || fromDate < bestFromDate) {
            bestFromDate = fromDate;
            bestEl = el;
          }
        });

        if (bestEl) this.computeAndRender(bestEl);
      }
    }
  }

  customElements.define("delivery-date", DeliveryDate);
}
